/**
 * @Author: Auto Generated
 * @Date: 2024-01-01
 * @LastEditors: Auto Generated
 * @LastEditTime: 2024-01-01
 */

export default {
    path: 'contract_config',
    component: () => import(/* webpackChunkName: "contract-config" */ '@/pages/system/ContractConfig'),
    meta: {title:'签约配置'}
  }
